export default __webpack_public_path__ + "static/vichy-9341484efdda198afb3cd26481955e5a.webm";